<template>
  <div class="app-select"
       :class="{
         'app-select_danger': danger
  }">
    <label class="app-select__label" :for="_uid" v-if="label">
      {{label}}
    </label>
    <vs-select v-model="model" :id="_uid" v-bind="$attrs" class="app-select__select">
      <slot />
    </vs-select>
    <transition name="fade">
      <div class="app-select__validation-error" v-if="danger && dangerText.length">
        {{dangerText}}
      </div>
    </transition>
  </div>

</template>

<script>
  export default {
    name: "AppSelect",
    props: {
      value: {},
      label: {
        type: String
      },
      danger: {
        type: Boolean,
        default: false
      },
      dangerText: {
        type: String,
      },
    },
    computed: {
      model: {
        get(){
          return this.value;
        },
        set(v){
          this.$emit('input', v);
          this.$emit('change', v);
          this.$emit('update:danger', false);
        }
      },
    }
  }
</script>

<style lang="scss">
.app-select{
  position: relative;

  &__label{
    color: #627084;
    font-size: 1rem;
    margin-bottom: 2px;
    display: block;
  }


  &__select{
    width: 100%;

    &.con-select .vs-select--input{
      display: block;
      width: 100%;
      max-width: 100%;
      padding: 8px 10px;
      font: inherit;
      font-size: 1rem;
      border-radius: 2px;
      height: 100%;
      border: 1px solid #ced4da;
      color: rgba(var(--app-content-color), 1);
    }
  }

  &_danger{
    .app-select{
      &__select{
        &.con-select .vs-select--input{
          border-color: rgba(var(--app-danger), 1);
        }
      }
    }
  }

  &__validation-error{
    display: inline-block;
    color: rgba(var(--app-danger), 1);
    overflow: hidden;
    transition: all .25s ease;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
    margin-top: 3px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 4px;
    line-height: 1.2;
    font-size: .71rem;
    border-radius: 2px;
    z-index: 100;
    position: absolute;
    top: 100%;
    left: 0;
  }
}
</style>
